import { useCallback } from "react";
import { updateUserProfile } from "@/shared/api/auth";
import { useAuth } from "./AuthProvider";
import { useLanguage } from "./LanguageProvider";
/**
 * Смена языка интерфейса. Меняет язык локально (LanguageProvider) сразу —
 * чтобы UI переключался мгновенно. Если пользователь авторизован,
 * персистит язык на бэке (PATCH /api/v1/public/users/me) и обновляет
 * профиль в контексте через refreshUser.
 *
 * refreshUser обязателен: для авторизованных каталог
 * (genres/reasons/...) отдаётся бэком по `user.language`, а не по телу
 * запроса. Без обновления профиля каталог перезагружался бы по старому
 * языку (гонка) и отставал на одно переключение.
 */
export const useSelectLanguage = () => {
    const { setLanguage } = useLanguage();
    const { isAuthenticated, refreshUser } = useAuth();
    return useCallback((language) => {
        setLanguage(language);
        if (isAuthenticated) {
            updateUserProfile({ language })
                .then(() => refreshUser())
                .catch((error) => {
                console.error("Failed to persist user language:", error);
            });
        }
    }, [setLanguage, isAuthenticated, refreshUser]);
};
